exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".modal__dropzone{padding:1rem 0;border-top:.0625rem dashed #b0b8bf;border-bottom:.0625rem dashed #b0b8bf}.modal__dropzone-instructions{color:#516a7d;text-align:center}.modal__dropzone .icon{display:block;width:4rem;margin:0 auto;margin-bottom:1rem}.modal__dropzone path{fill:#516a7d}.modal__dropzone-preview{text-align:center;color:#516a7d;cursor:pointer}.modal__dropzone-preview img,.modal__dropzone-preview video{width:100%}.modal__dropzone-preview-edit.icon{position:absolute;right:0;top:1rem;height:2rem;width:2rem;margin-bottom:0;padding:.5rem;background:#fff}.modal .thumbnail-drop__progress--overlay{top:1rem;bottom:1rem;height:calc(100% - 2rem);border-radius:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/components/ModalFileUpload/ModalFileUpload.scss
// module id = 687
// module chunks = 0